import { defineStore } from "pinia";
import useUtils from "@/Composables/useUtils";
import useRotas from '@/Composables/useRotas';

const route = useRotas();

const { mergeDeep } = useUtils();

export const useAuditorioStore = defineStore("auditorio", {
    state: () => {
        return {
            lotes: {},
            leiloes: {},
            idLoteSelecionadoLeilao: {},
            mensagens: [],
            processed: new Set(),
            ultimaAtualizacao: 0,
            processando: false,
            pararProcessamento: false,
        };
    },
    actions: {
        async carregamentoLeilaoInicial(idLeilao){

            const leilao = await (
                await fetch(route('auditorio.dadosLeilaoAuditorio', {
                    idLeilao: idLeilao,
                }), {
                    method: "GET",
                    credentials: "include",
                })
            ).json();
            this.leiloes[leilao.id] = leilao;
        },
        async carregamentoLotesInicial(idLeilao){

            const lotes = await (
                await fetch(route('auditorio.dadosLotesAuditorio', {
                    idLeilao: idLeilao,
                }), {
                    method: "GET",
                    credentials: "include",
                })
            ).json();

            lotes.forEach((lote) => {
                this.lotes[lote.id] = lote;

            });
        },
        async carregamentoLoteMomentoInicial(idLeilao, idLote){

            const lote = await (
                await fetch(route('auditorio.dadosLoteMomentoAuditorio', {idLeilao: idLeilao, idLote: idLote}), {
                    method: "GET",
                    credentials: "include",
                })
            ).json();

            this.lotes[lote.id] = lote;
            this.idLoteSelecionadoLeilao[lote.id_leilao] = lote.id;

        },


        carregarLeilao(leilao) {
            this.leiloes[leilao.id] = leilao;
        },
        atualizarLeilao(leilao) {
            this.leiloes[leilao.id] = mergeDeep(
                this.leiloes[leilao.id],
                leilao
            );
        },

        carregarLote(lote) {
            this.lotes[lote.id] = lote;
        },
        atualizarLote(lote) {
            this.lotes[lote.id] = mergeDeep(
                this.lotes[lote.id],
                lote
            );
        },

        carregarOuAtualizar(mensagem) {
            console.log('inicio atualizacao', this.lotes[mensagem.id]);
            if (mensagem.tipo === "lote") {
                if (this.lotes[mensagem.id]) {
                    this.atualizarLote(mensagem.dados);
                } else {
                    this.carregarLote(mensagem.dados);
                }
            } else if (mensagem.tipo === "leilao") {
                if (this.leiloes[mensagem.id]) {
                    this.atualizarLeilao(mensagem.dados);
                } else {
                    this.carregarLeilao(mensagem.dados);
                }
            } else if (mensagem.tipo === "statusLote") {
                this.lotes[mensagem.id].status_lote = mensagem.status;
                this.lotes[mensagem.id].proximoStatus = mensagem.proximoStatus;
            } else if (mensagem.tipo === "statusLeilao") {
                this.leiloes[mensagem.id].status_leilao = mensagem.status;
                this.leiloes[mensagem.id].proximoStatus = mensagem.proximoStatus;
            }
            console.log('final atualizacao', this.lotes[mensagem.id]);
        },
        enfileirar(mensagem) {
            if (mensagem.timestamp > this.ultimaAtualizacao) {
                console.log("Enfileirando", mensagem.messageId);
                this.mensagens.push(mensagem);
            } else {
                console.log("Descartando (Mais recente)", mensagem.message);
            }
        },
        async processar() {
            if (!this.pararProcessamento) {
                const mensagem = this.mensagens.shift();
                if (mensagem) {
                    const messageId = mensagem.messageId;
                    if (!this.processed.has(messageId)) {
                        console.log("Processando", messageId, mensagem);
                        this.carregarOuAtualizar(mensagem);
                        this.ultimaAtualizacao = mensagem.timestamp;
                        this.processed.add(messageId);
                        const size = this.processed.size;
                        console.log("Itens processados", size);
                        if (size > 10) {
                            const toRemove = size - 10;
                            console.log(
                                "Limpando itens processados",
                                size,
                                toRemove
                            );
                            for (let i = 0; i < toRemove; i += 1) {
                                this.processed.delete(
                                    this.processed.keys().next().value
                                );
                            }
                        }
                    } else {
                        console.log("Descartando (Duplicada)", messageId);
                    }
                }
                await new Promise((resolve) => setTimeout(resolve, 200));
                await this.processar();
            }
        },
        async processarFila() {
            console.log("Iniciando Processamento");
            if (!this.processando) {
                await this.processar();
                this.processando = true;
                this.pararProcessamento = false;
            }
        },
        pararFila() {
            console.log("Parando Processamento");
            this.pararProcessamento = true;
            this.processando = false;
        },
    },
});
